import { handleActions } from 'redux-actions';

import * as actions from '../actions';

const InitialState = null;

export const currentUserReducer = handleActions(
  {
    [actions.setCurrentUser]: (state, { payload: currentUser }) => currentUser,

    [actions.setCurrentUserCustomFields]: (currentUser, { payload: customFields }) => ({
      ...currentUser,
      CustomFields: customFields,
    }),

    [actions.setUserEmailVerified]: (state) => ({
      ...state,
      IsVerified: true,
    }),
  },
  InitialState
);
